import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-4" }
const _hoisted_3 = { class: "fw-bolder" }
const _hoisted_4 = {
  class: "fw-normal",
  style: {"font-size":"10px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-image fs-1 z-index-1" })
], -1)
const _hoisted_6 = { class: "d-flex justify-content-center gap-5" }
const _hoisted_7 = { class: "col-sm-8" }
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = {
  key: 1,
  class: "text-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/misc/noavailable.png",
  class: "h-400px",
  alt: ""
}, null, -1)
const _hoisted_13 = { class: "mb-5" }
const _hoisted_14 = { class: "fs-4" }
const _hoisted_15 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titleDialog,
    modelValue: _ctx.isModalVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isModalVisible) = $event)),
    class: "dialog-custom rounded",
    onOpen: _ctx.onOpen,
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    "lock-scroll": "",
    draggable: "",
    "destroy-on-close": "",
    top: "2vh",
    "append-to-body": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isModalVisible = false)),
          text: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
          ]),
          _: 1
        }),
        ((_ctx.action == 1 || _ctx.action == 2) && (_ctx.configInit?.mstatus == 'O'))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              loading: _ctx.loading,
              onClick: _ctx.validateAndSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.action == 1 ? _ctx.t('save') : _ctx.t('update')), 1)
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.configInit?.mstatus == 'O' || _ctx.form?.idteam)
        ? _withDirectives((_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            ref: "ruleFormRef",
            model: _ctx.form,
            "status-icon": "",
            rules: _ctx.rules,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, [
                    _createTextVNode(" Logo "),
                    _createElementVNode("span", _hoisted_4, "(" + _toDisplayString(_ctx.t('size')) + " 200x200px)", 1)
                  ]),
                  _createVNode(_component_el_image, {
                    class: "w-100 h-200px border rounded bg-white my-3",
                    src: _ctx.previewUrl
                  }, {
                    error: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["src"]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_upload, {
                      ref: "uploadRef",
                      headers: _ctx.headers,
                      data: _ctx.form,
                      name: "file",
                      action: _ctx.urlUpload,
                      accept: _ctx.extens,
                      multiple: false,
                      class: "upload-container",
                      "auto-upload": false,
                      "show-file-list": false,
                      "before-upload": _ctx.beforeUpload,
                      "on-change": _ctx.handleChange,
                      "on-error": _ctx.handleError,
                      "on-success": _ctx.handleSuccess
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "success",
                          round: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('select')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["headers", "data", "action", "accept", "before-upload", "on-change", "on-error", "on-success"]),
                    (_ctx.previewUrl)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          effect: "dark",
                          content: _ctx.t('delete'),
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("i", {
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removeFile && _ctx.removeFile(...args))),
                              class: "bi bi-trash text-hover-danger fs-1 cursor-pointer"
                            })
                          ]),
                          _: 1
                        }, 8, ["content"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_form_item, {
                    prop: "name",
                    label: _ctx.t('nameTeam'),
                    rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                        disabled: _ctx.configInit?.definition_teams == '0' ? false : true
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label", "rules"]),
                  _createVNode(_component_el_form_item, {
                    prop: "alias",
                    label: _ctx.t('nameShort'),
                    rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.alias,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.alias) = $event)),
                        disabled: _ctx.configInit?.definition_teams == '0' ? false : true
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label", "rules"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_el_form_item, {
                        prop: "color1",
                        label: _ctx.t('shirtColor'),
                        rules: [{ required: true, message: _ctx.t('obligatorie'), trigger: ['blur', 'change'] }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.color1,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.color1) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_el_form_item, {
                        prop: "color2",
                        label: _ctx.t('secondColor')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.color2,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.color2) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])), [
            [_directive_loading, _ctx.loading]
          ])
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("h1", _hoisted_13, _toDisplayString(_ctx.t('weresorry')), 1),
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.configInit?.message), 1)
          ]))
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpen", "onOpened", "onClosed"]))
}